import { createContext, useContext } from 'react';
import type { InventorySort, InventoryVisibility } from '../service/types';

export interface InventoryFiltersContextValue {
  searchDraft: string;
  onSearchChange: (nextQuery: string) => void;
  category: string;
  categoryOptions: ReadonlyArray<{ value: string; label: string }>;
  onCategoryChange: (nextCategory: string) => void;
  visibility: InventoryVisibility;
  visibilityOptions: ReadonlyArray<{ value: string; label: string }>;
  onVisibilityChange: (nextVisibility: string) => void;
  sort: InventorySort;
  sortOptions: ReadonlyArray<{ value: string; label: string }>;
  onSortChange: (nextSort: string) => void;
  missingImage: boolean;
  needsPhotoCount: number;
  onToggleMissingImage: (next: boolean) => void;
  hasResettableFilters: boolean;
  onResetFilters: () => void;
  pageSize: number;
  pageSizeOptions: ReadonlyArray<number>;
  onPageSizeChange: (nextValue: string) => void;
}

export const inventoryFiltersContext = createContext<InventoryFiltersContextValue | null>(null);

export function useInventoryFilters() {
  const value = useContext(inventoryFiltersContext);
  if (value === null) {
    throw new Error('useInventoryFilters must be used within InventoryPageProvider');
  }

  return value;
}
